import { ISelectItem } from "@/types";
import { ICompany } from "@/types/company";

export class Company implements ICompany {
  public id = 0;
  public name = "";
  public display_name = "";
  public email = "";
  public email_verified_at = "";
  public tel = "";
  public password = "";
  public address = "";
  public created_at = "";
  public updated_at = "";

  constructor(props?: ICompany) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }

  public static toSelectItem(company: ICompany): ISelectItem {
    return {
      text: company.name,
      value: company.id,
    };
  }
}
